import { useTranslation } from 'react-i18next';
import { useProfessionalsChip } from '../hooks/useProfessionalsChip';
import type { UnallocatedFilterKey, UnallocatedFilterState } from '../hooks/useUnallocatedFilters';
import type { FilterOption } from '../types/Checks';
import { type FilterChip, FilterChipList } from './FilterChipList';

type UnallocatedFilterChipsProps = {
  filterState: UnallocatedFilterState;
  /** Nomes de Tipo/Situação; enquanto carrega, o chip mostra o id. */
  filterOptions: { contractTypes: FilterOption[]; contractStatuses: FilterOption[] } | undefined;
};

export function UnallocatedFilterChips({
  filterState,
  filterOptions,
}: UnallocatedFilterChipsProps) {
  const { t } = useTranslation('alocacao');
  const { filters, professionals } = filterState;
  const professionalsChip = useProfessionalsChip();

  const chips: FilterChip<UnallocatedFilterKey>[] = [];
  const contains = (key: UnallocatedFilterKey, field: string, value: string | undefined) => {
    if (value) chips.push({ key, text: t('filtros.chips.contem', { field, value }) });
  };
  const selected = (
    key: UnallocatedFilterKey,
    field: string,
    ids: number[] | undefined,
    options: FilterOption[] | undefined,
  ) => {
    if (!ids?.length) return;
    const name = ids
      .map((id) => options?.find((option) => option.id === id)?.name ?? String(id))
      .join(', ');
    chips.push({ key, text: t('filtros.chips.selecionado', { field, name }) });
  };

  const professionalsText = professionalsChip(professionals);
  if (professionalsText) chips.push({ key: 'professional', ...professionalsText });
  contains('professionalSearch', t('consultas.colunas.profissional'), filters.professionalSearch);
  selected(
    'contractTypeIds',
    t('consultas.colunas.tipo'),
    filters.contractTypeIds,
    filterOptions?.contractTypes,
  );
  contains('profileSearch', t('consultas.colunas.perfil'), filters.profileSearch);
  selected(
    'contractStatusIds',
    t('consultas.colunas.situacao'),
    filters.contractStatusIds,
    filterOptions?.contractStatuses,
  );

  return (
    <FilterChipList
      chips={chips}
      onRemove={filterState.clearFilter}
      onClear={filterState.clearFilters}
    />
  );
}
